// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-99a7fa7e] .ck-editor-big .ck-editor__editable{min-height:500px}[data-v-99a7fa7e] .ck-editor__editable{min-height:250px}[data-v-99a7fa7e] .not-valid .ck-editor{border:1px solid red}.not-valid~.invalid-feedback[data-v-99a7fa7e]{display:block;text-align:left}[data-v-99a7fa7e] .ck.ck-tooltip .ck-tooltip__text{color:#fff!important}", ""]);
// Exports
module.exports = exports;
